module.exports = __webpack_public_path__ + "img/boy.96e080d0.png";